import { apiRequest } from "../api/apiService";
import apiClient from "../api/apiClient";

/* ================= LATE FEE CONFIG ================= */

export const getLateFeeConfig = async (groupId) => {
  const res = await apiClient.get(
    "/admin/group/config",
    { params: { groupId } }
  );
  return res.data;
};

export const saveLateFeeConfig = async (payload) => {
  console.log("📤 Save Late Fee Config:", payload);

  return apiRequest({
    method: "POST",
    url: "/admin/group/config/save",
    data: payload,
  });
};

/* ================= ORG DETAILS CONFIG ================= */

// export const getOrgDetails = async (groupId) => {
//   console.log("📤 Get Org Details:", groupId);

//   return apiRequest({
//     method: "GET",
//     url: "/admin/group/details",
//     params: { groupId },
//   });
// };

// export const saveOrgDetails = async (payload) => {
//   console.log("📤 Save Org Details:", payload);

//   return apiRequest({
//     method: "POST",
//     url: "/admin/group/details/save",
//     data: payload,
//   });
// };
